import { render, staticRenderFns } from "./energy.vue?vue&type=template&id=66b94ff8&scoped=true"
import script from "./energy.vue?vue&type=script&lang=js"
export * from "./energy.vue?vue&type=script&lang=js"
import style0 from "./energy.vue?vue&type=style&index=0&id=66b94ff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b94ff8",
  null
  
)

export default component.exports